import type { TranslateService } from '@ngx-translate/core';
import type {
  DefaultMenuItem,
  GetContextMenuItemsParams,
  MenuItemDef,
} from 'ag-grid-enterprise';
import type { TreeExpansionController } from './tree-expansion.controller';

export function buildTreeExpansionMenuItems<TData>(
  params: GetContextMenuItemsParams<TData>,
  expansion: TreeExpansionController<TData>,
  translate: TranslateService,
): (DefaultMenuItem | MenuItemDef)[] {
  const defaultItems = (params.defaultItems ?? []) as DefaultMenuItem[];
  const node = params.node;
  if (!node || !expansion.isGroup(node)) return defaultItems;

  const api = params.api;
  const state = expansion.inspect(api, node);
  return [
    {
      name: translate.instant('GRID_TREE.EXPAND_ADDITIONAL_LEVEL'),
      disabled: !expansion.canExpandOneMoreLevel(state),
      action: () => expansion.expandOneMoreLevel(state),
    },
    {
      name: translate.instant('GRID_TREE.EXPAND_ALL_CHILDREN'),
      disabled: !expansion.canExpandNodeFully(state),
      action: () => expansion.expandNodeFully(api, state),
    },
    {
      name: translate.instant('GRID_TREE.COLLAPSE_ONE_LEVEL'),
      disabled: !expansion.canCollapseOneLevel(state),
      action: () => expansion.collapseOneLevel(state),
    },
    {
      name: translate.instant('GRID_TREE.COLLAPSE_ALL_CHILDREN'),
      disabled: !expansion.canCollapseNodeFully(state),
      action: () => expansion.collapseNodeFully(state),
    },
    'separator',
    ...defaultItems,
  ];
}
